import React from "react";
import './loading.css';
import {useLocation} from "react-router-dom";
import {isRcsProject} from "@/utils";

const PageLoading = ({style = {}, title = "加载中，请稍后"}) => {
  if(isRcsProject()){
     return (
         <div id="loadingBox" style={style}>
              <img alt="" src="https://static2.253.com/ups/images/page_loading.gif" style={{width: 250}} />
         </div>
     )
  }
  return (
    <div id="loadingBox" style={style}>
      <div className="loading-inner">
        <div className="bsload bsload1" />
        <div className="bsload bsload2" />
        <div className="bsload bsload3" />
      </div>
      {title && <div className="loading-title">{title}</div>}
    </div>
  )
}
export default PageLoading